'use es6';

import { createSelector } from 'reselect';
import { Map as ImmutableMap } from 'immutable';
import { getHasMABAccess } from './authSelectors';
export const getMAB = state => state.mab;
export const getMABStatus = createSelector([getMAB], mab => mab.status);
export const getMABVariants = createSelector([getMAB], mab => mab.variants);
export const getMABVariantsWithoutMetrics = createSelector([getMABVariants], variants => variants.valueSeq().map(variation => ImmutableMap({
  id: variation.get('id'),
  name: variation.get('name')
})).toList());
export const getMABExperiment = createSelector([getMAB], mab => mab.experiment);
export const getMABExperimentId = createSelector([getMABExperiment], experiment => experiment.id);
export const getHasMAB = createSelector([getHasMABAccess, getMABVariants], (hasMabAccess, variants) => hasMabAccess && variants.size > 0);
export const getMABMetric = createSelector([getMABExperiment], experiment => experiment.metric);
export const getMABStartedAt = createSelector([getMABExperiment], experiment => experiment.startedAt);
export const getMABIds = createSelector([getMABVariants], variants => variants.keySeq().toList());
export const getMABHasStarted = createSelector([getMABStartedAt], startedAt => startedAt > 0);
export const getMABMasterId = createSelector([getMABIds], mabIds => mabIds.first());